import { initReactI18next } from 'react-i18next';

import { resources } from '@repo/constants/translationStatic';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
